import hooks from "./hooks";
import constants from "./constants";

export default {
  hooks,
  states: constants.states,
  successMesssages: constants.successMessages,
};
